<div
  class="media-player-container d-flex flex-column"
  [class.old-item]="oldItem && !ignoreOldItem"
  [class.review-link-page]="!!reviewLink"
  [class.h-100]="isNotCleanOrBeingTranscoded"
  [class.fullscreen]="isFullscreen"
  [class.comments-expanded]="!isCommentsCollapsed">
  <!-- <mtm-pdf-transcode-error></mtm-pdf-transcode-error> -->
  <div
    *ngIf="item?.status === 'uploading'"
    class="mtm-file-download-upload-preview d-flex flex-column m-auto"
    [style.max-width]="'540px'"
    [style.width]="'100%'">
    <div class="d-flex align-items-center p-2 m-auto _600 w-100" [style-border-bottom]="'1px solid #ccc'">
      <span class="d-inlone-block m-auto">{{ 'uploadInProgress' | translate }}</span>
    </div>
    <div class="d-flex p-3" *ngFor="let file of item.data">
      <div class="mtm-file-download-upload-preview-icon">
        <img type="image/svg+xml" [src]="getFileTypeIcon(file)" onError="this.src='assets/img/icons/file.svg'" />
      </div>
      <div class="mtm-file-download-upload-preview-meta flex-fill d-flex flex-column">
        <div class="d-flex align-items-center pt-1">
          <div class="filename me-auto flex-fill pt-1 pb-1" fileNameDisplay [fileName]="file?.displayName"> </div>
          <div class="progress-in-text ms-auto pt-1 pb-1">{{ file?.progress }}%</div>
        </div>
        <div class="mtm-file-download-upload-preview-progress mt-2">
          <div class="progress-background" [style.width]="`${file.progress || 0}%`"></div>
        </div>
      </div>
    </div>
  </div>

  <mtm-asset-scan-info
    [file]="item"
    *ngIf="!!item && item.status !== 'uploading' && item.malwareScanningStatus != MalwareScanningStatus.Clean"
    (scanFinished)="handleScanStatusChange()">
  </mtm-asset-scan-info>

  <div
    class="d-block"
    [class.h-100]="isLoadingOrBeingTranscoded"
    *ngIf="item?.status !== 'uploading' && item?.malwareScanningStatus == MalwareScanningStatus.Clean">
    <div *ngIf="showCloseButton" class="file-close-btn d-flex justify-content-between pb-3">
      <span class="text-white f-12 p-1">{{ item?.displayName || '' }}</span>
      <button (click)="activeModal.close()" class="btn btn-sm btn-danger f-12"> Close</button>
    </div>
    <!-- Video -->
    <div
      *ngIf="mediaType === 'video' && !isError"
      class="media-player annotation-content-preview"
      [style.width]="width"
      #videoContainer
      id="videoContainer"
      resizeObserverElement
      [parentElementContainer]="parentElementContainer"
      [element]="'.video-js-element-width-track'"
      [enableSizeObserver]="enableResponsive && !oldItem && enableVideoAnnotation"
      [bottomGap]="0"
      [isVideoJs]="true">
      <ng-container [ngTemplateOutlet]="topMediaContainer" *ngIf="!hideTopMediaInfo"></ng-container>
      <!-- <div class="d-flex align-items-center justify-content-center flex-column position-relative video-player video-js-element-width-track"
           [ngClass]="{ 'annotation-active': enableVideoAnnotation, 'drawing-hidden': !canAddAnnotationComment }"
           [class.fullscreen]="isFullscreen">
        <video id="videoJsEl" class="video-js m-0 video-js-element-container video-js-element-container--without-comment-bar" controls #videoPlayer
               [class.release-preview]="isReleasePreview" [class.share-link-preview]="isShareLinkPreview"></video>
        <div *ngIf="previewSubtitle" class="vjs-text-track-display">
          <div style="position: absolute; inset: 0px; margin: 1.5%;">
            <div class="vjs-text-track-cue vjs-text-track-cue-en" lang="en"
                 style="direction: ltr; writing-mode: horizontal-tb; unicode-bidi: plaintext; text-align: center; font: 17.32px sans-serif; white-space: pre-line; position: absolute; width: 620.8px; inset: 325.4px 0px 0px; height: 21px; background-color: rgba(0, 0, 0, 0);">
              <div
                   style="color: rgb(255, 255, 255); background-color: rgb(0, 0, 0); position: relative; inset: 0px; display: inline; writing-mode: horizontal-tb; unicode-bidi: plaintext; font-family: sans-serif;">
                The quick brown fox jumps over the lazy dog
              </div>
            </div>
          </div>
        </div>
        <div class="d-block annotation-bar-container mx-auto mt-auto w-100"
             *ngIf="enableVideoAnnotation && !hideAnnotationToolbar && isPlayerReady">
          <mtm-videojs-annotation-bar-list [annotations]="annotations" [player]="player" [projectId]="projectId"
                                           [sectionId]="sectionId" [subsectionId]="subsectionId"
                                           [participants]="projectParticipants"
                                           [typeId]="typeId" [item]="item" [annotationPlugin]="annotationPlugin"
                                           [isPlayerReady]="isPlayerReady"
                                           [isVideo]="true" [instanceId]="instanceId">
          </mtm-videojs-annotation-bar-list>
        </div>
      </div> -->
      <mtm-video-annotation
        [enableVideoAnnotation]="enableVideoAnnotation"
        [canAddAnnotationComment]="canAddAnnotationComment"
        [previewSubtitle]="previewSubtitle"
        [(player)]="player"
        [projectId]="projectId"
        [sectionId]="sectionId"
        [subsectionId]="subsectionId"
        [participants]="projectParticipants"
        [typeId]="typeId"
        [item]="item"
        [file]="file"
        [directPreview]="directPreview"
        [(videoOptions)]="videoOptions"
        [annotations]="annotations"
        [(isPlayerReady)]="isPlayerReady"
        [customPaddingTop]="customPaddingTop"
        [(oldItem)]="oldItem"
        [autoPlayVideo]="autoPlayVideo"
        [height]="height"
        [width]="width"
        [instanceId]="instanceId"
        [miniPlayer]="miniPlayer"
        [enableSubtitle]="enableSubtitle"
        [subtitle]="subtitle"
        [portfolioPreview]="portfolioPreview"
        [videoSubtitle]="videoSubtitle"
        (videoPlayerReady)="videoPlayerReady.emit()"
        [videoPreloadMethod]="videoPreloadMethod"
        [(isError)]="isError"
        [(isBusy)]="isBusy"
        (videoDownload)="sendDownloadGAEvent($event)"
        [(metadataCheckTimeout)]="metadataCheckTimeout"
        (videoInitializationStarted)="cancelMetadataCheck()"
        [hideAnnotationToolbar]="hideAnnotationToolbar"
        (videoThumbnailLoad)="onVideoThumbnailLoad()"
        (videoThumbnailLoadError)="onVideoThumbnailLoadError()"
        (playerOnFullscreenChange)="onVideoPlayerFullscreenChange()"
        [shareLinkPreview]="shareLinkPreview"></mtm-video-annotation>
      <ng-container [ngTemplateOutlet]="assetListContainer"></ng-container>
      <ng-container [ngTemplateOutlet]="assetInfoContainer"></ng-container>
    </div>
    <!--Video Error-->
    <div
      *ngIf="mediaType === 'video' && !file?.metadata"
      class="loading-container processing-video-container d-flex align-items-center justify-content-center min-h-250"
      id="loadingVideoContainer"
      #loadingVideoContainer>
      <div class="loading-circle d-flex align-items-center justify-content-center flex-column">
        <span>{{ 'asset_processingFile' | translate }}</span>
        <span>{{ 'asset_pleaseWait' | translate }}</span>
      </div>
    </div>
    <div
      *ngIf="mediaType === 'video'"
      class="loading-container h-100 d-flex hidden-container justify-content-center"
      id="loadingVideoContainer"
      #loadingVideoContainer
      [ngClass]="{ 'min-h-250': !portfolioPreview }">
      <div
        *ngIf="enableVideoAnnotation"
        class="loading-box d-flex align-items-center justify-content-center flex-column">
        <div class="loading-icon">
          <div class="spinner"></div>
          <img alt="" height="20" width="28" src="../../../../../assets/img/icons/download/process_red.png" />
        </div>
        <span class="heading-text">Please be patient while we load and transcode your video</span>
      </div>
      <div
        *ngIf="!enableVideoAnnotation && !portfolioPreview"
        class="preview-loading-box d-flex align-items-center justify-content-center flex-column">
        <div class="loading-icon">
          <div class="spinner"></div>
          <img alt="" height="20" width="28" src="../../../../../assets/img/icons/download/process_red.png" />
        </div>
        <span class="heading-text">Please be patient while we load and transcode your video</span>
      </div>
      <div
        *ngIf="portfolioPreview && !enableVideoAnnotation"
        class="portfolio-loading-box h-100 w-100 d-flex justify-content-center align-items-center"
        [style.min-height]="previewContainerHeight">
        <div class="spinner"></div>
        <img alt="" height="20" width="28" src="../../../../../assets/img/icons/download/process_red.png" />
      </div>
    </div>
    <!-- AUDIO ANNOTATION -->
    <div
      *ngIf="mediaType === 'audio' && enableAudioAnnotation"
      class="audio-component-container"
      resizeObserverElement
      [parentElementContainer]="parentElementContainer"
      [element]="'.audio-element-component'"
      [minHeight]="220"
      [enableSizeObserver]="enableResponsive"
      [isAudio]="true"
      [bottomGap]="audioGap"
      [ngClass]="{
        'w-100 audio-parent-container-forComment': ngClassState.valueOf() == true,
        'col w-100  h-100 audio-container': ngClassState.valueOf() == false,
      }">
      <mtm-audio-annotation
        #audioAnnotationCmp
        class="w-100 h-100"
        [projectId]="projectId"
        [sectionId]="sectionId"
        [subsectionId]="subsectionId"
        [typeId]="typeId"
        [item]="item"
        [hideAnnotationToolbar]="hideAnnotationToolbar"
        [enableAudioAnnotation]="enableAudioAnnotation"
        [participants]="projectParticipants"
        [annotations]="annotations"
        [authUser]="userInfo"
        [hideTopMediaInfo]="hideTopMediaInfo"
        [hasEditPermission]="hasEditPermission"
        [assetListTemplate]="assetListContainer"
        [assetInfoTemplate]="assetInfoContainer"
        [topMediaInfoTemplate]="topMediaContainer"
        [reviewLink]="subSectionState?.reviewLink"
        [shareLinkPreview]="shareLinkPreview"
        [instanceId]="instanceId">
      </mtm-audio-annotation>
    </div>
    <!-- AUDIO -->
    <div *ngIf="mediaType === 'audio' && !enableAudioAnnotation" class="audio-container-wrapper">
      <ng-container [ngTemplateOutlet]="topMediaContainer" *ngIf="!hideTopMediaInfo"></ng-container>
      <div class="position-relative asset-container">
        <div
          class="col w-100 h-100 audio-container"
          [ngClass]="{
            'min-h-250': !portfolioPreview,
            'portfolio-preview': portfolioPreview,
            'reorder-preview': reorderPreview,
          }">
          <!-- <img [ngClass]="{'min-h-250 min-h-470': ngClassState.valueOf()==true,'w-100 h-100 image min-h-250 ':ngClassState.valueOf()==false}"
          src="../../../../../assets/img/thumpnails/audio-file.png"> -->
          <div *ngIf="uuid" class="wave-form-container" id="{{ uuid }}"></div>
          <audio class="w-100 audio" controls #mtmAudioPlayer [preload]="audioPreloadMethod">
            <source />
          </audio>
        </div>
        <ng-container [ngTemplateOutlet]="assetListContainer"></ng-container>
        <ng-container [ngTemplateOutlet]="assetInfoContainer"></ng-container>
      </div>
    </div>
    <!-- PDF -->
    <div *ngIf="mediaType === 'pdf' && file" class="w-100 h-100 d-flex flex-column document-container">
      <ng-container *ngIf="!isLoadingOrBeingTranscoded && !commentOnly">
        <div class="d-flex flex-column" *ngIf="!item.hasPage || !enablePage || useFallbackDisplay">
          <mtm-comment-annotation
            class=""
            [annotations]="annotations"
            [item]="item"
            [projectId]="projectId"
            [sectionId]="sectionId"
            [subsectionId]="subsectionId"
            [hideAnnotationToolbar]="hideAnnotationToolbar"
            *ngIf="enableGeneralComments"
            [hideTopMediaInfo]="hideTopMediaInfo"
            [instanceId]="instanceId"
            [shareLinkPreview]="shareLinkPreview"
            [participants]="projectParticipants"></mtm-comment-annotation>

          <iframe
            [src]="file.previewSRC | safe"
            class="w-100 pdf-file-frame-container"
            [class.release-pdf-preview]="isReleasePreview"
            [class.share-link-preview]="isShareLinkPreview"
            frameborder="0"></iframe>
          <ng-container [ngTemplateOutlet]="assetListContainer"></ng-container>
          <ng-container [ngTemplateOutlet]="assetInfoContainer"></ng-container>
        </div>
        <ng-container *ngIf="item.hasPage && enablePage && !useFallbackDisplay">
          <div
            class="w-100 h-100 min-h-250 d-flex flex-column align-items-center justify-content-center pdf-loader"
            *ngIf="fileTranscodingStatus === 'in-progress'">
            <span class="d-inline-block mb-2">
              <mtm-loading-spinner [size]="24"></mtm-loading-spinner>
            </span>
            <span class="heading-text">{{ 'mediaPlayer_transcoding_inProgress' | translate }}</span>
          </div>

          <ng-container *ngIf="fileTranscodingStatus === 'success'">
            <ng-container [ngTemplateOutlet]="topMediaContainer" *ngIf="!hideTopMediaInfo"></ng-container>
            <div class="position-relative document-container">
              <div
                class="w-100 pdf-file-frame-container d-flex has-page-container"
                [class.release-pdf-preview]="isReleasePreview"
                [class.share-link-preview]="isShareLinkPreview"
                *ngIf="item.hasPage">
                <!--
                <div class="pdf-slide-list h-100 me-3">
                  <mtm-pdf-slider-component [filePages]="filePages" [activePage]="activePage"></mtm-pdf-slider-component>
                </div>
                -->
                <div class="pdf-annotation-preview flex-fill" *ngIf="activePage && annotationsLoaded">
                  <mtm-image-annotation
                    class="w-100 h-100"
                    [projectId]="projectId"
                    [sectionId]="sectionId"
                    [subsectionId]="subsectionId"
                    [typeId]="item.id"
                    [item]="activePage"
                    [hideAnnotationToolbar]="hideAnnotationToolbar"
                    [participants]="projectParticipants"
                    [annotations]="annotations"
                    [authUser]="userInfo"
                    [hasEditPermission]="hasEditPermission"
                    [topMediaTemplate]="topMediaContainer"
                    [reviewLink]="subSectionState?.reviewLink"
                    [assetListTemplate]="assetListContainer"
                    [assetInfoTemplate]="assetInfoContainer"
                    [shareLinkPreview]="shareLinkPreview"
                    [instanceId]="instanceId">
                  </mtm-image-annotation>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="isLoadingOrBeingTranscoded && !commentOnly">
        <div
          class="w-100 h-100 min-h-250 d-flex flex-column align-items-center justify-content-center processing-container">
          <div class="loading-circle d-flex align-items-center justify-content-center flex-column">
            <span>{{ 'asset_processingFile' | translate }}</span>
            <span>{{ 'asset_pleaseWait' | translate }}</span>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="commentOnly">
        <mtm-comment-annotation
          class=""
          [annotations]="annotations"
          [item]="item"
          [projectId]="projectId"
          [sectionId]="sectionId"
          [subsectionId]="subsectionId"
          [hideAnnotationToolbar]="hideAnnotationToolbar"
          *ngIf="enableGeneralComments"
          [hideTopMediaInfo]="hideTopMediaInfo"
          [instanceId]="instanceId"
          [shareLinkPreview]="shareLinkPreview"
          [participants]="projectParticipants"></mtm-comment-annotation>
      </ng-container>

      <!-- <mtm-pdf-annotation class="w-100 h-100" [item]="item"></mtm-pdf-annotation> -->
    </div>
    <!--  IMAGE ANNOTATION   -->
    <div
      class="d-flex align-items-center justify-content-center media-container"
      *ngIf="mediaType === 'image' && enableImageAnnotation"
      [class.share-link-preview]="isShareLinkPreview"
      [class.release-preview]="isReleasePreview">
      <mtm-image-annotation
        class="w-100 h-100"
        [projectId]="projectId"
        [sectionId]="sectionId"
        [subsectionId]="subsectionId"
        [typeId]="typeId"
        [item]="item"
        [participants]="projectParticipants"
        [hideAnnotationToolbar]="hideAnnotationToolbar"
        [annotations]="annotations"
        [authUser]="userInfo"
        [hideTopMediaInfo]="hideTopMediaInfo"
        [isSubsectionBarVisible]="isSubsectionBarVisible"
        [hasEditPermission]="hasEditPermission"
        [topMediaTemplate]="topMediaContainer"
        [reviewLink]="subSectionState?.reviewLink"
        [assetListTemplate]="assetListContainer"
        [assetInfoTemplate]="assetInfoContainer"
        [instanceId]="instanceId"
        [shareLinkPreview]="shareLinkPreview"
        #imageAnnotation1>
      </mtm-image-annotation>
    </div>
    <!-- Image -->
    <div
      class="image-non-annotation d-flex flex-column"
      *ngIf="(mediaType === 'image' || mediaType === 'convertibleImage') && !enableImageAnnotation"
      resizeObserverElement
      [parentElementContainer]="parentElementContainer || '.asset-container'"
      [minHeight]="156"
      [isImage]="true"
      [element]="'.image-preview-element'"
      [enableSizeObserver]="enableResponsive"
      [bottomGap]="8">
      <ng-container [ngTemplateOutlet]="topMediaContainer" *ngIf="!hideTopMediaInfo"></ng-container>
      <div
        class="position-relative asset-container"
        [ngClass]="{ 'd-flex align-items-center justify-content-center': isKpfPreview }"
        [style.background-color]="'#000'">
        <div
          class="card-img card-background image-preview-element"
          [ngClass]="{
            'card-img-view': mode === 'view',
            '11rem': fillContainer,
            'img-cover': isSideImg,
            'min-h-250 h-100': isKpfPreview ? true : !portfolioPreview && !enableResponsive,
            'portfolio-preview': portfolioPreview,
          }"
          [style.background-image]="imgSrc"
          (click)="showImageInNewTab()">
        </div>
        <div class="hidden">
          <mtm-file-download-control
            [file]="file"
            [displayType]="'icon'"
            [iconSize]="24"
            [uniqueControlId]="`media-player-download-not-exists${file.projectId}-${file.sectionId}-${file.subSectionId}-${file.id}`">
          </mtm-file-download-control>
        </div>
        <ng-container [ngTemplateOutlet]="assetListContainer"></ng-container>
        <ng-container [ngTemplateOutlet]="assetInfoContainer"></ng-container>
      </div>
    </div>

    <!-- URL -->
    <div class="card-img w-100 h-100 min-h-250" *ngIf="mediaType === 'url'">
      <ng-container [ngTemplateOutlet]="topMediaContainer" *ngIf="!hideTopMediaInfo"></ng-container>
      <div class="position-relative asset-container">
        <ng-container [ngTemplateOutlet]="assetListContainer"></ng-container>
        <ng-container [ngTemplateOutlet]="assetInfoContainer"></ng-container>
        <embed-video [fix]="fix" #youtube [height]="'100%'" [width]="'100%'" [link]="item"> </embed-video>
      </div>
    </div>
    <!-- Subtitle -->
    <div class="w-100 h-100 min-h-250" *ngIf="mediaType === 'subtitle'">
      <mtm-comment-annotation
        class=""
        [annotations]="annotations"
        [item]="item"
        [projectId]="projectId"
        [sectionId]="sectionId"
        [subsectionId]="subsectionId"
        [hideAnnotationToolbar]="hideAnnotationToolbar"
        [hideTopMediaInfo]="hideTopMediaInfo"
        [instanceId]="instanceId"
        [shareLinkPreview]="shareLinkPreview"
        [participants]="projectParticipants"></mtm-comment-annotation>
      <ng-container [ngTemplateOutlet]="topMediaContainer" *ngIf="!hideTopMediaInfo"></ng-container>
      <div class="card-img w-100 h-100 min-h-250 d-flex flex-column align-items-center justify-content-center">
        <img class="mb-2" alt="" height="120" width="120" src="../../../../../assets/img/srtIco.svg" />
        <div class="d-flex flex-column align-items-center">
          <span>{{ file.displayName }}</span>
          <span>{{ formatSizeUnits(file.size) }}</span>
          <span>{{ file.addedTime | date: 'M/d/yy h:mm a' }}</span>
        </div>
        <div *ngIf="showDownloadButtonIfNotPreviewAble" class="download-button-control mt-2">
          <mtm-file-download-control
            [file]="file"
            [displayType]="'icon'"
            [iconSize]="24"
            [uniqueControlId]="`media-player-download-not-exists${file.projectId}-${file.sectionId}-${file.subSectionId}-${file.id}`">
          </mtm-file-download-control>
        </div>
      </div>
    </div>
    <div class="keynote-container w-100 h-100" *ngIf="mediaType === 'keynote' && !commentOnly">
      <mtm-pdf-transcode-error
        [file]="file"
        [transcodingType]="TranscodingTypes.KeyNote"
        [forceCodec]="true"
        (fileReplaced)="checkTranscodingReplacementFile($event)"
        *ngIf="fileTranscodingStatus === 'failed' && !isLoading"></mtm-pdf-transcode-error>
      <div
        class="d-flex flex-column document-container"
        *ngIf="(!item.hasPage || !enablePage || useFallbackDisplay) && fileTranscodingStatus === 'success'">
        <iframe
          [src]="file.previewSRC | safe"
          class="w-100 pdf-file-frame-container"
          [class.release-pdf-preview]="isReleasePreview"
          frameborder="0"></iframe>
      </div>
      <ng-container *ngIf="isLoading || fileTranscodingStatus === 'in-progress'">
        <div
          class="w-100 h-100 min-h-250 d-flex flex-column align-items-center justify-content-center processing-container">
          <div class="loading-circle d-flex align-items-center justify-content-center flex-column">
            <span>{{ 'asset_processingFile' | translate }}</span>
            <span>{{ 'asset_pleaseWait' | translate }}</span>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="download-link not-supported-container w-100 h-100 min-h-250" *ngIf="isFileNotSupported">
      <mtm-comment-annotation
        class=""
        [annotations]="annotations"
        [item]="item"
        [projectId]="projectId"
        [sectionId]="sectionId"
        [subsectionId]="subsectionId"
        [instanceId]="instanceId"
        *ngIf="enableGeneralComments"
        [hideAnnotationToolbar]="hideAnnotationToolbar"
        [hideTopMediaInfo]="hideTopMediaInfo"
        [shareLinkPreview]="shareLinkPreview"
        [participants]="projectParticipants"></mtm-comment-annotation>
      <ng-container [ngTemplateOutlet]="topMediaContainer" *ngIf="!hideTopMediaInfo"></ng-container>
      <!--
      <span class="not-previewable-message" [style.text-align]="'center'"
        [innerHtml]="'fileNotPreviewAble' | translate"></span>
      <div class="w-100 h-100 min-h-250 d-flex flex-column align-items-center justify-content-center">
        <div *ngIf="showDownloadButtonIfNotPreviewAble" class="download-button-control mt-2">
          <mtm-file-download-control [file]="file" [displayType]="'icon'" [iconSize]="24"
            [uniqueControlId]="'media-player-download-not-exists' + file.projectId + '-' + file.sectionId + '-' + file.subSectionId + '-' + file.id">
          </mtm-file-download-control>
        </div>
      </div>
      -->
      <div
        class="content-container position-relative asset-container w-100 h-100 d-flex flex-column align-items-center justify-content-center py-4 py-xl-0">
        <ng-container [ngTemplateOutlet]="assetListContainer"></ng-container>
        <ng-container [ngTemplateOutlet]="assetInfoContainer"></ng-container>
        <img
          class="d-block mx-auto mb-3"
          src="/assets/img/versioning/unknown-file.svg"
          alt="unknown file"
          width="36"
          height="46" />
        <div
          class="not-supported-title text-uppercase mb-3"
          [innerHTML]="'mediaPlayer_notSupported_title' | translate: displayInfo"></div>
        <div class="not-supported-desc text-center mb-3">
          <span class="d-block">{{ 'mediaPlayer_notSupported_desc1' | translate }}</span>
          <span class="d-block mb-3">{{ 'mediaPlayer_notSupported_desc2' | translate }}</span>
          <span class="d-block">{{ 'mediaPlayer_notSupported_desc3' | translate }}</span>
        </div>
        <!--
        <button class="btn btn-download d-flex align-items-center" *ngIf="enableGeneralComments">
          <img class="me-2" src="/assets/img/versioning/unknown-file-download.svg" alt="Download" width="22" height="22" />
          <span class="text-uppercase">{{'mediaPlayer_downloadFile' | translate }}</span>
        </button>
        -->

        <mtm-file-download-control
          [file]="file"
          [displayType]="'unknown-download'"
          *ngIf="showDownloadButtonIfNotPreviewAble"
          [uniqueControlId]="`media-player-download-not-exists${file.projectId}-${file.sectionId}-${file.subSectionId}-${file.id}`">
        </mtm-file-download-control>
      </div>
    </div>

    <!--ppt -->

    <div
      class="w-100 h-100 min-h-250 d-flex flex-column doc-preview"
      *ngIf="mediaType === 'powerpoint' && file && !commentOnly">
      <div
        class="w-100 h-100 min-h-250 d-flex flex-column office-failed"
        *ngIf="fileTranscodingStatus === 'failed' && !isLoading">
        <mtm-pdf-transcode-error
          [file]="file"
          [transcodingType]="TranscodingTypes.Pdf"
          (fileReplaced)="checkTranscodingReplacementFile($event)"></mtm-pdf-transcode-error>
      </div>
      <div
        class="d-flex flex-column document-container"
        *ngIf="(!item.hasPage || !enablePage || useFallbackDisplay) && fileTranscodingStatus === 'success'">
        <iframe
          [src]="file.previewSRC | safe"
          class="w-100 pdf-file-frame-container"
          [class.release-pdf-preview]="isReleasePreview"
          frameborder="0"></iframe>
      </div>
      <ng-container *ngIf="isLoading || fileTranscodingStatus === 'in-progress'">
        <div
          class="w-100 h-100 min-h-250 d-flex flex-column align-items-center justify-content-center processing-container">
          <div class="loading-circle d-flex align-items-center justify-content-center flex-column">
            <span>{{ 'asset_processingFile' | translate }}</span>
            <span>{{ 'asset_pleaseWait' | translate }}</span>
          </div>
        </div>
      </ng-container>
    </div>

    <!--officeDoc-->

    <div
      class="w-100 h-100 min-h-250 d-flex flex-column doc-preview"
      *ngIf="mediaType === 'officeDoc' && file && !commentOnly">
      <div
        class="w-100 h-100 min-h-250 d-flex flex-column align-items-center justify-content-center office-loader"
        *ngIf="fileTranscodingStatus === 'in-progress' || isLoading">
        <span class="d-inline-block mb-2">
          <mtm-loading-spinner [size]="24"></mtm-loading-spinner>
        </span>
        <span class="heading-text" *ngIf="fileTranscodingStatus === 'in-progress'">{{
          'mediaPlayer_transcoding_inProgress' | translate
        }}</span>
        <span class="heading-text" *ngIf="isLoading">{{ 'loading' | translate }}</span>
      </div>

      <div
        class="w-100 h-100 min-h-250 d-flex flex-column office-failed"
        *ngIf="fileTranscodingStatus === 'failed' && !isLoading">
        <mtm-pdf-transcode-error
          [file]="file"
          [transcodingType]="TranscodingTypes.Pdf"
          (fileReplaced)="checkTranscodingReplacementFile($event)"></mtm-pdf-transcode-error>
      </div>

      <ng-container *ngIf="fileTranscodingStatus === 'success'">
        <mtm-comment-annotation
          class=""
          [annotations]="annotations"
          [item]="item"
          [projectId]="projectId"
          [sectionId]="sectionId"
          [subsectionId]="subsectionId"
          [instanceId]="instanceId"
          [hideAnnotationToolbar]="hideAnnotationToolbar"
          [hideTopMediaInfo]="hideTopMediaInfo"
          [shareLinkPreview]="shareLinkPreview"
          *ngIf="enableGeneralComments"></mtm-comment-annotation>
        <ng-container [ngTemplateOutlet]="topMediaContainer" *ngIf="!hideTopMediaInfo"></ng-container>
        <div class="position-relative document-container">
          <div class="d-flex flex-column" *ngIf="!item.hasPage">
            <mtm-comment-annotation
              class=""
              [annotations]="annotations"
              [item]="item"
              [projectId]="projectId"
              [sectionId]="sectionId"
              [subsectionId]="subsectionId"
              [hideAnnotationToolbar]="hideAnnotationToolbar"
              *ngIf="enableGeneralComments"
              [hideTopMediaInfo]="hideTopMediaInfo"
              [instanceId]="instanceId"
              [shareLinkPreview]="shareLinkPreview"
              [participants]="projectParticipants"></mtm-comment-annotation>
            <iframe
              [src]="file.previewSRC | safe"
              class="w-100 pdf-file-frame-container"
              [class.release-pdf-preview]="isReleasePreview"
              [class.share-link-preview]="isShareLinkPreview"
              frameborder="0"></iframe>
          </div>
          <div
            class="w-100 pdf-file-frame-container d-flex has-page-container"
            [class.release-pdf-preview]="isReleasePreview"
            [class.share-link-preview]="isShareLinkPreview"
            *ngIf="item.hasPage">
            <!--
            <div class="pdf-slide-list h-100 me-3">
              <mtm-pdf-slider-component [filePages]="filePages" [activePage]="activePage"></mtm-pdf-slider-component>
            </div>
            -->
            <div class="pdf-annotation-preview flex-fill" *ngIf="activePage && !pageReload">
              <mtm-image-annotation
                class="w-100 h-100"
                [projectId]="projectId"
                [sectionId]="sectionId"
                [subsectionId]="subsectionId"
                [typeId]="item.id"
                [item]="activePage"
                [hideAnnotationToolbar]="hideAnnotationToolbar"
                [participants]="projectParticipants"
                [annotations]="annotations"
                [authUser]="userInfo"
                [hasEditPermission]="hasEditPermission"
                [topMediaTemplate]="topMediaContainer"
                [reviewLink]="subSectionState?.reviewLink"
                [assetListTemplate]="assetListContainer"
                [assetInfoTemplate]="assetInfoContainer"
                [shareLinkPreview]="shareLinkPreview"
                [instanceId]="instanceId">
              </mtm-image-annotation>
            </div>
          </div>
          <ng-container [ngTemplateOutlet]="assetListContainer"></ng-container>
          <ng-container [ngTemplateOutlet]="assetInfoContainer"></ng-container>
        </div>
      </ng-container>
    </div>

    <div
      class="w-100 h-100 min-h-250 media-container"
      *ngIf="mediaType === 'convertibleImage' && file && enableImageAnnotation">
      <ng-container *ngIf="fileTranscodingStatus === 'in-progress' || isLoading">
        <div
          class="w-100 h-100 min-h-250 d-flex flex-column align-items-center justify-content-center processing-container">
          <div class="loading-circle d-flex align-items-center justify-content-center flex-column">
            <span>{{ 'asset_processingFile' | translate }}</span>
            <span>{{ 'asset_pleaseWait' | translate }}</span>
          </div>
        </div>
      </ng-container>

      <div
        class="w-100 h-100 min-h-250 d-flex flex-column office-failed"
        *ngIf="fileTranscodingStatus === 'failed' && !isLoading">
        <mtm-pdf-transcode-error
          [file]="file"
          [transcodingType]="TranscodingTypes.Png"
          (fileReplaced)="checkTranscodingReplacementFile($event)"></mtm-pdf-transcode-error>
      </div>
      <ng-container *ngIf="fileTranscodingStatus === 'success'">
        <mtm-image-annotation
          class="w-100 h-100"
          [projectId]="projectId"
          [sectionId]="sectionId"
          [subsectionId]="subsectionId"
          [typeId]="typeId"
          [item]="item"
          [hideAnnotationToolbar]="hideAnnotationToolbar"
          [participants]="projectParticipants"
          [annotations]="annotations"
          [authUser]="userInfo"
          [hasEditPermission]="hasEditPermission"
          [topMediaTemplate]="topMediaContainer"
          [reviewLink]="subSectionState?.reviewLink"
          [assetListTemplate]="assetListContainer"
          [assetInfoTemplate]="assetInfoContainer"
          [shareLinkPreview]="shareLinkPreview"
          [instanceId]="instanceId">
        </mtm-image-annotation>
      </ng-container>
    </div>
  </div>

  <ng-template #topMediaContainer>
    <top-media-info
      class="d-none"
      *ngIf="!hideTopMediaInfo"
      [subSectionState]="subSectionState"
      [isBusy]="isBusy"
      [hasEditPermission]="hasEditPermission"
      (switchVersionClick)="switchVersion($event)"
      (manageVersionsClick)="showManageVersions()"
      (newVersionClick)="createNewVersion()"
      (downloadAssetClick)="downloadAsset()"
      (assetListClick)="toggleAssetList()"
      (assetInfoClick)="toggleAssetInfo()"
      (shareClick)="openReviewLinkSettings()"
      [assetListVisible]="isAssetListVisible"
      [versionListVisible]="isVersionListVisible"
      [shareable]="shareable"></top-media-info>
  </ng-template>

  <ng-template #assetListContainer>
    <subsection-preview-asset-list
      *ngIf="isAssetListVisible"
      [activeFile]="item"
      (fileClick)="handleAssetClick()"></subsection-preview-asset-list>
  </ng-template>

  <ng-template #assetInfoContainer>
    <mtm-asset-info [file]="file" [(visible)]="isAssetInfoVisible"></mtm-asset-info>
  </ng-template>
</div>
